<template>
  <!-- 文章标题 -->
  <div class="wiki-detail-title">
    <!-- 词条 -->
    <!-- <em v-if="detail.entry_id > 0">{{ $t("entry") }}</em> -->
    <!-- tag -->
    <span v-if="detail.type == 4 && isShowTag(detail.tag)" :class="['tag-item', `tag-${detail.tag}`]">
      {{ tagInfos[detail.tag] }}
    </span>
    <!-- 类型 -->
    <span v-if="detail.type == 17" :class="['tag-item', `tag-6`]">
      提问
    </span>
    <span>
      <h1 class="title" v-html="xss(detail.title)"></h1>
      <!-- <device-source :source="detail.source" :fontSize="20" /> -->
    </span>
  </div>
</template>

<script>
// import DeviceSource from "../../components/deviceSource";
export default {
  name: "DetailTitle",
  props: {
    detail: Object
  },
  // components: { DeviceSource },
  data() {
    return {
      tagInfos: {
        3: "工会",
        4: "交友",
        5: "攻略",
        6: "提问"
      }
    };
  },
  computed: {
    isShowTag() {
      return val => {
        return val == 3 || val == 4 || val == 5 || val == 6;
      };
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.wiki-detail-title {
  // display: flex;
  // align-items: center;
  margin-bottom: 15px;
  font-size: 24px;
  color: #333;
  .title {
    display: inline;
    font-size: 24px;
    color: #333;
  }
  .tag-item {
    display: inline-block;
    width: 48px;
    height: 24px;
    margin-right: 8px;
    text-align: center;
    line-height: 24px;
    color: #fff;
    font-size: 14px;
    border-radius: 2px;
    vertical-align: middle;
    &.tag-3 {
      background-color: #4d8bff;
    }
    &.tag-5 {
      background-color: #4d8bff;
    }
    &.tag-4 {
      background-color: #ed7272;
    }
    &.tag-6 {
      background-color: #de9e3c;
    }
  }

  em {
    display: inline-block;
    width: 48px;
    height: 24px;
    background: rgba(30, 30, 30, 0.65);
    border-radius: 2px;
    font-size: 14px;
    color: #fff;
    line-height: 24px;
    text-align: center;
    font-style: normal;
    vertical-align: middle;
    margin-right: 6px;
  }

  span {
    width: 95%;
    font-weight: bold;
  }
}
</style>
